export enum UserValidityStatusEnum {
    ACTIVE = 'ATIVO',
    INACTIVE = 'INATIVO',
    PENDING = 'PENDENTE',
}

export const getUserValidityStatusValues = (): string[] => Object.values(UserValidityStatusEnum);
